import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
let pending;

export default function usePublicFooter(initialFooter) {
  const [footer, setFooter] = useState(initialFooter || {});
  const [error, setError] = useState('');
  useEffect(() => {
    if (initialFooter) {
      setFooter(initialFooter);
      return undefined;
    }
    let active = true;
    if (!pending) {
      pending = axios.get(`${BACKEND_URL}/api/v2/public/footer`)
        .then(response => {
          if (!response.data?.footer) throw new Error('CMS footer is missing');
          return response.data.footer;
        })
        .finally(() => { pending = null; });
    }
    pending.then(value => {
      if (active) { setFooter(value); setError(''); }
    }).catch(() => {
      if (active) setError('Contact details could not be loaded. Please reload this page or visit Contact.');
    });
    return () => { active = false; };
  }, [initialFooter]);
  return { footer, error };
}
